<template>
    <footer>
        <div class="main">
            <div class="content">
                <div class="cf f16">
                    <div
                        id="divselect1"
                        class="fl selecttags"
                    >
                        <el-select
                            placeholder="政府网站"
                            class="select"
                            style="border-radius:0px;"
                            v-model="selectValue"
                        >
                            <el-option
                                v-for="item in zfList"
                                :key="item.text"
                                :value="item.text"
                            >
                                <a
                                    :href="item.href"
                                    target="_blank"
                                >{{ item.text }}</a>
                            </el-option>
                        </el-select>

                        <el-select
                            placeholder="招投标行业网站"
                            class="select"
                            v-model="selectValue"
                        >
                            <el-option
                                v-for="item in zfList"
                                :key="item.text"
                                :value="item.text"
                            >
                                <a
                                    :href="item.href"
                                    target="_blank"
                                >{{ item.text }}</a>
                            </el-option>
                        </el-select>

                        <el-select
                            placeholder="公共资源交易平台"
                            class="select"
                            v-model="selectValue"
                        >
                            <el-option
                                v-for="item in zfList"
                                :key="item.text"
                                :value="item.text"
                            >
                                <a
                                    :href="item.href"
                                    target="_blank"
                                >{{ item.text }}</a>
                            </el-option>
                        </el-select>

                        <el-select
                            placeholder="友情链接网站"
                            class="select"
                            v-model="selectValue"
                        >
                            <el-option
                                v-for="item in zfList"
                                :key="item.text"
                                :value="item.text"
                            >
                                <a
                                    :href="item.href"
                                    target="_blank"
                                >{{ item.text }}</a>
                            </el-option>
                        </el-select>
                    </div>

                </div>
            </div>
        </div>
        <div class="footer">
            <div class="info">
                <div><img src="/images/rqcode.jpg"></div>
                <div class="f16">
                    网站主办单位：<label>{{head.companyname}}</label>
                    <br>公司地址：{{head.address}}
                    <br>联系方式：<span class="foottel">0951-<i>6899808</i></span>
                </div>
            </div>
        </div>
        <div
            class="copyright"
            id="accessNum"
        >
            ICP备案编号：
            <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                class="copyright_link"
            >
                {{head.icp}}{{head.icp}}
            </a>

            <div class="visit-box" v-if="visitNum > 0">
                您好！您是第
                <span class="visit-num"> {{visitNum}} </span>
                位访问本站的人
            </div>
        </div>
    </footer>
</template>

<script>
import CONFIG from '@config/config';
import $axios from 'axios';

export default {
    data() {
        return {
            qrcode: [],
            selectValue: '',
            zfList: [
                {
                    text: '宁夏回族自治区人民政府',
                    href: 'http://www.nx.gov.cn/',
                },
                {
                    text: '宁夏政务服务网',
                    href: 'https://zwfw.nx.gov.cn/?loginSuccess=false',
                },
                {
                    text: '银川市人民政府',
                    href: 'http://www.yinchuan.gov.cn/',
                },
            ],
            head: CONFIG.head,
            visitNum: 0,
        };
    },
    computed: {
        info() {
            return this.$store.state.config.baseInfo;
        },
    },
    methods: {
        init() {},

        getNum() {
            $axios
                .get(`http://www.ycjs.com.cn/prod-api/yxPlatform/accessNum/getAccessNum`, {})
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.visitNum = data.data || 0;
                    }
                });
        },
    },
    mounted() {
        this.init();
        this.getNum();
    },
};
</script>

<style scoped lang="scss">
@import '@css/var.scss';

$textColor: #fff;

footer {
    background: #1a212a;
}

.main {
    background: #dddddd;
    height: 78px;
    .content {
        .selecttags {
            position: relative;
            z-index: 10000;
            margin: 18px 2%;
            // margin-left: 2%;
            // margin-right: 2%;
            margin-top: 18px;
            display: flex;
            justify-content: space-between;

            .select {
                width: 21%;
            }
        }
    }
}

::v-deep .el-select:hover .el-input__inner {
    border-color: none;
}

::v-deep .el-input__inner {
    color: #000;
    border-radius: 0px;
    font-size: 16px;
    border: none;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: none !important;
}

::v-deep .el-input__inner::placeholder {
    color: #000;
    font-weight: 400;
    font-size: 16px;
}
::v-deep a {
    color: #000;
    font-weight: 400;
    font-size: 16px;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #ccc;
}

.footer {
    width: 865px;
    margin: 0 auto;
    padding: 20px 0px 0 0px;

    .info {
        display: flex;
        color: #86898e;
        line-height: 42px;
        margin-top: 10px;

        .f16 {
            font-size: 16px;
            padding: 13px 0 13px 44px;
        }

        label {
            color: #ffffff;
        }

        .foottel {
            color: #cf312a;
            i {
                font-style: normal;
                font-size: 28px;
            }
        }
    }
}

.copyright {
    background-color: #111111;
    height: 48px;
    line-height: 48px;
    color: #adadad;
    font-size: 14px;
    text-align: center;

    .copyright_link {
        color: #adadad;
        &:hover {
            color: #cf312a;
            text-decoration: underline;
            text-decoration-color: #cf312a;
        }
    }

    .visit-box{
        display: inline-block;
        margin-left: 30px;
        .visit-num{
            color: #cf312a;
        }
    }
}
</style>
